import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import ModalCrud from "./UpdatePaidModal";
import Pagination from "../Pagination/Pagination";

export default function UpdatePaid() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const PAGE_SIZE = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [pageExams, setPageExams] = useState([]);

  const [isLoading, setLoading] = useState(false);
  const [exams, setExams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [examDetail, setExamDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    exams.length === 0 ? GetExams() : FilterExams(exams, currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const FilterExams = (exams, page) => {
    const examsPage = exams.filter(
      (u, idx) => idx >= (page - 1) * PAGE_SIZE && idx < page * PAGE_SIZE
    );
    setPageExams(examsPage);
  };

  const GetExams = async () => {
    setLoading(true);
    var moment = require("moment");

    let exams = await axios
      .get(
        `${API_URL}/users?populate=exams.grade,exams.dojo,exams.examiner&filters[exams][id][$notNull]=true&filters[exams][datePaid][$null]=true&pagination[pageSize]=2000`,
        headerRequest
      )
      .then((users) => {
        let exams = [];
        for (let i = 0; i < users.data.length; i++) {
          const u = users.data[i];
          if (u.exams?.length) {
            for (let j = 0; j < u.exams.length; j++) {
              const e = u.exams[j];
              if (e.datePaid != undefined && e.datePaid != null) continue;
              let x = {
                userId: u.id,
                docNumber: u.docNumber,
                fullname: u.lastname + ", " + u.name,
                examId: e.id,
                date: e.date,
                datePaid: e.datePaid,
                gradeId: e.grade.id,
                grade: e.grade.name,
                dojo: e.dojo.name,
                examiner: e.examiner?.name,
              };
              exams.push(x);
            }
          }
        }
        // sort by date desc, dojo, grade desc
        exams.sort(function (a, b) {
          return (
            moment(b.date).toDate() - moment(a.date).toDate() ||
            (a.examiner != null && a.examiner.localeCompare(b.examiner)) ||
            b.gradeId - a.gradeId
          );
        });

        setExams(exams);
        setPagination({ total: exams.length });
        FilterExams(exams, 1);
        setLoading(false);

        return exams;
      });
  };

  const EditExam = (data) => {
    setExamDetail(data);
    setShowModal(true);
  };

  const renderData = (
    <>
      <Table
        striped
        hover
        size="sm"
        responsive="sm"
        style={{ fontSize: ".8em" }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>DNI</th>
            <th>Nombre</th>
            <th>Fecha</th>
            <th>Graduación</th>
            <th>Dojo</th>
            <th>Examinador</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {exams.length < 1 ? (
            <tr>
              <td colSpan="8" align="center">
                No hay exámenes pendientes de procesar.
              </td>
            </tr>
          ) : (
            pageExams.map((exam) => (
              <tr key={exam.examId}>
                <td align="center">{exam.userId}</td>
                <td align="center">{exam.docNumber}</td>
                <td align="left">{exam.fullname}</td>
                <td align="center">{exam.date}</td>
                <td align="center">{exam.grade}</td>
                <td align="left">{exam.dojo}</td>
                <td align="left">{exam.examiner}</td>
                <td align="center">
                  <Button
                    size="sm"
                    className="btn-xs"
                    onClick={() => EditExam(exam)}
                    variant="warning"
                  >
                    Editar
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>ACTUALIZAR PAGO EXAMENES</h4>
      <p></p>
      {isLoading ? <Spinner animation="border" /> : renderData}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          exam={examDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetExams();
          }}
        />
      )}
    </Container>
  );
}
